import { useEffect, useState } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Capabilities from "@/components/Capabilities";
import About from "@/components/About";
import Certificates from "@/components/Certificates";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Engineering = ({ t, lang, setLang }) => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Navbar t={t.nav} lang={lang} setLang={setLang} />
      <main>
        <Hero t={t.hero} />
        <Marquee items={t.marquee} />
        <Capabilities t={t.capabilities} />
        <About t={t.about} />
        <Certificates t={t.certificates} />
        <Contact t={t.contact} lang={lang} />
      </main>
      <Footer t={t.footer} />
    </>
  );
};

export default Engineering;
